import React from "react";
const handleHomeButton = () => {
    window.location.href = "/sampleHome";
  };

const LoggedOutPage = () => {
  return (
    <div className="flex flex-col bg-lightmaroon h-screen pt-20">
        
      <div className="text-center text-4xl text-white font-medium mb-10">You have been logged out!</div>
      <div className="text-center text-xl text-white mb-10"> Thank you </div>
      <button className="text-white" onClick={handleHomeButton}>Go to Home Page</button>
      <div className="flex justify-center items-center">
        <img
          loading="lazy"
          src={require("../assets/novelology_newlogo.png")}
          className="object-cover h-44 w-46"
        />
      </div>
    </div>
  );
};

export default LoggedOutPage;
